import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=419c5672&scoped=true"
import script from "./sheet.vue?vue&type=script&lang=ts"
export * from "./sheet.vue?vue&type=script&lang=ts"
import style0 from "./sheet.vue?vue&type=style&index=0&id=419c5672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c5672",
  null
  
)

export default component.exports